import fonts from "../../styles/fonts";
import palette from "../../styles/palette";

export default {
    wrapper: {
        textAlign: "center",
        padding: 10
    } as React.CSSProperties,
    container: {
        display: "inline-block",
        width: "100%",
        maxWidth: 1000
    } as React.CSSProperties,
    toolBar: {
        textAlign: "left",
        marginBottom: 20
    } as React.CSSProperties,
    title: {
        ...fonts.title,
        margin: 0,
        color: palette.text.primary,
    } as React.CSSProperties,
    overview: {
        textAlign: "right"
    } as React.CSSProperties,
    bookingRef: {
        fontSize: 40,
        margin: 0,
        color: palette.text.secondary,
    } as React.CSSProperties,
    vehicleStatus: {
        fontSize: 20,
        margin: 0,
        color: palette.text.secondary,
    } as React.CSSProperties,
    bookingStatus: {
        fontSize: 20,
        margin: 0,
        color: palette.text.secondary,
    } as React.CSSProperties,
    card: {
        margin: 10
    } as React.CSSProperties,
    fabPosition: {
        position: "fixed",
        right: 70,
        bottom: 50,
    } as React.CSSProperties,
    fab: {
        backgroundColor: "rgb(20, 207, 176)",
        color: "white",
        marginBottom: 10,
        position: "relative"
    } as React.CSSProperties,
    DatePicker: {
        display: "none",
    }
};